import { options } from './Options'

export const NBRStatusOptions: options[] = [
  { label: '', value: 'new' },
  { label: 'Approved by Ops', value: 'approved_by_ops' },
  { label: 'Pending Approval', value: 'pending' },
  { label: 'Rejected by Ops', value: 'rejected' }
]
